import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Plus } from 'lucide-react'
import { Button } from '@/components/shadcn/button'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import type { GenericInAppNotificationDefinitionResponse } from '@/api/model/genericInAppNotificationDefinitionResponse'
import { NotificationsTable } from './table-components/NotificationsTable'
import { NotificationDialog } from './components/NotificationDialog'
import { NotificationDetailDialog } from './components/NotificationDetailDialog'

export default function NotificationsPage() {
  const { t } = useTranslation('notifications')
  const [details, setDetails] = useState<GenericInAppNotificationDefinitionResponse | null>(null)

  const [isNotificationDialogOpen, setIsNotificationDialogOpen] = useState(false)
  const [notification, setNotification] = useState<GenericInAppNotificationDefinitionResponse | null>(null)

  const handleCreate = () => {
    setNotification(null)
    setIsNotificationDialogOpen(true)
  }

  const handleEdit = (notification: GenericInAppNotificationDefinitionResponse) => {
    setNotification(notification)
    setIsNotificationDialogOpen(true)
  }

  const handleNotificationOpenChange = (open: boolean) => {
    setIsNotificationDialogOpen(open)
    if (!open) setNotification(null)
  }

  const handleDetail = (notification: GenericInAppNotificationDefinitionResponse) => {
    setDetails(notification)
  }

  const handleDetailsOpenChange = (open: boolean) => {
    if (!open) setDetails(null)
  }

  return (
    <>
      <PageLayout>
        <PageHeader title={t('header.title')} description={t('header.description')}>
          <Button onClick={handleCreate}>
            <Plus className="size-4" />
            {t('header.create')}
          </Button>
        </PageHeader>

        <NotificationsTable
          onEdit={handleEdit}
          onDetail={handleDetail}
        />
      </PageLayout>

      <NotificationDialog
        isOpen={isNotificationDialogOpen}
        onOpenChange={handleNotificationOpenChange}
        notification={notification}
      />

      {details && (
        <NotificationDetailDialog
          notification={details}
          onClose={() => handleDetailsOpenChange(false)}
        />
      )}
    </>
  )
}
